import React, { useEffect, useState } from 'react';
import { addAccount } from '../../actions/accountActions';
import { useDispatch, useSelector } from 'react-redux';
import MainWrapper from '../../components/MainWrapper';
import Select from 'react-select';
import { getAllReportsByProject } from '../../actions/reportActions';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import { useParams } from 'react-router-dom';
import DriveWrapper from './components/DriveWrapper';


const AddAccountDrive = ({ match }) => {
  const dispatch = useDispatch();
  const [reportList, setReportList] = useState([]);
  const [selected, setSelectedReport] = useState([]);
  const [newAccount, setNewAccount] = useState({
    username: '',
    password: '',
    report2Access: [],
    role: '',
    projectId: '',
  });
  const searchParams = useParams();
  const { id } = searchParams;

  useEffect(() => {
    if (id) {
      dispatch(getAllReportsByProject(id));
      const acc = { ...newAccount };
      acc.projectId = id;
      setNewAccount(acc);
    }
  }, [dispatch, id]);

  const { reports, error: reportError } = useSelector((state) => state.reportR);
  const { account, loading, error } = useSelector((state) => state.accountR);

  useEffect(() => {
    if (reports) {
      const newArr = reports.map((e) => {
        return {
          label: e.name,
          value: e._id,
        };
      });
      setReportList(newArr);
    }
  }, [reports]);

  useEffect(() => {
    // clear inputs
    if (account) {
      const acc = { ...newAccount };
      acc.username = '';
      acc.password = '';
      acc.report2Access = [];
      acc.role = '';
      setNewAccount(acc);
      setSelectedReport([]);
    }
  }, [account]);

  const onChange = (e) => {
    const { name, value } = e.target;
    const acc = { ...newAccount };

    acc[name] = value;
    setNewAccount(acc);
  };

  function addEditProperty(item) {
    setSelectedReport({ 0: item });

    const acc = { ...newAccount };
    acc['report2Access'] = item;
    setNewAccount(acc);
  }
  function onFormSubmit(e) {
    e.preventDefault();
    dispatch(addAccount({ account: newAccount }));
  }

  function back() {
    return window.history.back();
  }
  // console.log('account', account);
  // console.log('newAccount', newAccount);
  return (
    <DriveWrapper>
      {error ? (
        <Message color="danger"> {error} </Message>
      ) : (
        <div className="container">
          {loading && <Loader />}

          {account && <Message color="success"> Successful create. </Message>}

          <div className="card p-3 mb-2 container">
            <div className="mb-4">
              <button onClick={back} className="btn btn-primary">
                Back
              </button>
            </div>
            <h5 className="lead text-center shadow py-2">Create Account</h5>

            <form style={{ padding: '5%' }} onSubmit={onFormSubmit}>
              <div>
                <label htmlFor="username">
                  Your Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="username"
                  placeholder="Enter user name"
                  value={newAccount.username}
                  onChange={(e) => onChange(e)}
                  required
                />
              </div>
              <div className="mt-3">
                <label htmlFor="password">
                  Password <span className="text-danger">*</span>
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder="Enter password"
                  value={newAccount.password}
                  onChange={(e) => onChange(e)}
                  required
                />
              </div>

              {reportError ? null : (
                <div className="mt-3">
                  <label htmlFor="name">Report To Access</label>
                  <Select
                    isMulti={true}
                    value={selected[0]}
                    onChange={(e) => addEditProperty(e)}
                    options={reportList}
                  />
                </div>
              )}

              <div className="mt-3">
                <label htmlFor="name">Permission Level</label>
                <select
                  value={newAccount.role}
                  name="role"
                  className="form-select"
                  onChange={(e) => onChange(e)}
                  required
                >
                  <option value="">Select</option>
                  <option value="admin">Admin</option>
                  <option value="super">Super Admin</option>
                  <option value="validator">Validator</option>
                </select>
              </div>

              <div className="mt-3">
                <button className="btn btn-primary" type="submit">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </DriveWrapper>
  );
};

export default AddAccountDrive;
